import classNames from 'classnames';
import { isEqual } from 'lodash';

import React from 'react';

import Checkbox from '../../Checkbox/Checkbox';

import styles from './styles.module.scss';

interface OptionProps {
  id: string,
  name: string,
  type?: 'checkbox' | 'radio',
  value: string | number,
  children: string,
  className?: string,
  checked?: boolean,
  onClick?: (e: React.MouseEvent<HTMLLabelElement>) => void,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
  small?: boolean,
  isActive?: boolean,
}

const Option = ({
  id,
  children,
  name,
  type = 'radio',
  value,
  checked,
  className,
  onClick,
  onChange,
  small,
  isActive,
}: OptionProps) => {
  const sm = small ? styles.small : '';
  const cn = classNames(styles.option, sm, className);

  return (
    <div className={cn}>
      {type === 'checkbox'
        ? (
          <Checkbox
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            onClick={onClick}
            label={children}
            checked={checked}
            small={small}
            className={styles.checkBox}
          />
        )
        : (
          <>
            <input
              name={name}
              type="radio"
              id={id}
              value={value}
              onChange={onChange}
              checked={checked}
              data-cy="radio"
              className={styles.defaultInput}
            />
            <label
              htmlFor={id}
              onClick={onClick}
              data-cy="option"
            >
              {children}
            </label>
          </>
        )}
      {isActive && <span className={styles.isActiveRound} />}
    </div>
  );
};

export default React.memo(Option, isEqual);
